/**
 * @file This file contains configuration for idle actions NPCs can take when empty-handed.
 * @module npcIdleActionsConfig
 */

/**
 * @typedef {Object} NpcIdleActionConfig
 * @property {string} actionName - A descriptive name for the action (e.g., 'dance', 'wave').
 * @property {number} probability - The chance (0 to 1) of this action occurring on a free move.
 * @property {string} effect - The key for the temporary visual effect to display.
 * @property {number} duration - The duration of the action in milliseconds.
 */

/**
 * An array of possible idle actions for NPCs. The system will iterate through this
 * list and perform the first action whose probability check passes.
 * @type {NpcIdleActionConfig[]}
 */
export const npcIdleActionsConfig = [
    {
        actionName: 'dance',
        probability: 0.02, // 2% chance
        effect: 'dancing',
        duration: 3000
    },
    {
        actionName: 'sing',
        probability: 0.03, // 3% chance
        effect: 'music_notes',
        duration: 2500
    },
    {
        actionName: 'wave',
        probability: 0.05, // 5% chance
        effect: 'waving_hand',
        duration: 2000
    },
    {
        actionName: 'sleep',
        probability: 0.01, // 1% chance
        effect: 'sleeping',
        duration: 5000
    }
];